<template>
  <div :style="{ height: 'var(--max-content-height)', overflow: 'hidden' }">
    <livechat-search v-model="showSearch"></livechat-search>
    <div id="livechat" :style="{ height: 'inherit' }">
      <v-layout fill-height>
        <!-- <v-flex shrink fill-height>
          <template v-if="$store.state.livechat.pageid">
            <livechat-pagelist
              :value="$store.state.livechat.pageid"
              @changePage="changePage"
            ></livechat-pagelist>
          </template>
        </v-flex> -->
        <v-flex fill-height style="position: relative; min-width: 0">
          <v-layout fill-height>
            <v-flex
              :style="{ display: 'flex', flexDirection: 'column' }"
              style="border-right: 1px solid #eee; flex-grow: 0; min-width: 320px; width: 320px"
            >
              <div id="chattype">
                <template v-if="isQuickFilter || searchlist.length == 0">
                  <livechat-tab
                    :newchatnotify="newchatnotify"
                    @onsearch="showSearch = true"
                  ></livechat-tab>
                </template>
                <template v-else>
                  <livechat-search-box @onsearch="showSearch = true"></livechat-search-box>
                  <v-divider></v-divider>
                </template>
              </div>

              <div v-if="$store.state.livechat.app" :style="{ flex: 1, overflow: 'hidden' }">
                <users
                  v-if="$store.state.livechat.type == 'admin'"
                  :app="$store.state.livechat.app"
                  :usersearching="usersearching"
                  :filter="filter"
                  :type="'admin'"
                  @onChangeFilter="handleChangeFilter"
                ></users>
                <users
                  v-if="$store.state.livechat.type == 'bot'"
                  :app="$store.state.livechat.app"
                  :usersearching="usersearching"
                  :filter="filter"
                  :type="'bot'"
                  @onChangeFilter="handleChangeFilter"
                ></users>
              </div>
            </v-flex>
            <v-flex :style="{ minWidth: 0 }">
              <v-layout fill-height>
                <v-flex
                  v-if="selectedUser"
                  :key="`chat_${selectedUser.userid}_${selectedUser.type}`"
                  style="border-right: 1px solid #eee; position: relative; max-width: 70%"
                  fill-height
                >
                  <chatbox
                    :key="selectedUser.userid"
                    :newchatnotify="newchatnotify"
                    @endSession="onEndSession"
                    @openSession="onOpenSession"
                  ></chatbox>
                </v-flex>
                <v-flex v-if="selectedUser" style="position: relative; max-width: 30%" fill-height>
                  <livechat-chattool :selected-user="selectedUser"></livechat-chattool>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <audio
      v-show="false"
      id="noti_sound"
      src="/static/sound/noti_sound.m4a"
      type="audio/x-m4a"
      preload="auto"
      controls
    ></audio>
  </div>
</template>

<script>
import Livechat from './Livechat.js'
export default {
  mixins: [Livechat]
}
</script>

<style></style>
<style>
.newnotifycount {
  line-height: 16px;
  border-radius: 24px;
  position: absolute;
  right: 3px;
  top: 5px;
  padding-left: 3px;
  padding-right: 3px;
  background-color: #ff0935;
  font-size: 10px;
  color: white;
  height: 16px;
  min-width: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/Livechat.vue